export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/viewer/icon-setting-light-301e27b721ab756e4c8896b1645af0f1.svg";